import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { DashboardWidget } from './dashboard-widget.model';
import { DashboardWidgetRegistryService } from './dashboard-widget-registry.service';

/**
 * Registers a {@link DashboardWidget} during application bootstrap so Home can
 * project it. Call from a feature `provideXxx()` bundle.
 *
 * @param widget View metadata, or a factory run in injection context so the
 * widget can read flags (same `id` replaces a previous registration).
 */
export function provideDashboardWidget(
  widget: DashboardWidget | (() => DashboardWidget),
): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const resolved = typeof widget === 'function' ? widget() : widget;
      inject(DashboardWidgetRegistryService).register(resolved);
    }),
  ]);
}
